import React, { Component } from 'react';

class OnScreenKeyboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showKeyboard: false,
			kbInput: ''
		};

		this.kbPressed = false;
		this.toggleTimer = null;
		this.startToggle = this.startToggle.bind(this);
		this.endToggle = this.endToggle.bind(this);
		this.handleKbInputChange = this.handleKbInputChange.bind(this);
		this.handleKbKeyup = this.handleKbKeyup.bind(this);
	}

	componentDidMount() {
		this.kbInput.addEventListener('keyup', this.handleKbKeyup);
	}

	componentWillUnmount() {
		clearTimeout(this.toggleTimer);
		this.kbInput.removeEventListener('keyup', this.handleKbKeyup);
	}

	startToggle(e) {
		e.stopPropagation();

		if (!this.state.showKeyboard) {
			this.toggleTimer = setTimeout(() => {
				this.setState({showKeyboard: true});
			}, 5000);
		}
	}

	endToggle(e) {
		e.preventDefault();
		e.stopPropagation();
		clearTimeout(this.toggleTimer);

		if (this.state.showKeyboard) {
			this.setState({showKeyboard: false});
			this.kbInput.focus();
		}
	}

	handleKbInputChange(e) {
		if (this.kbPressed) {
			return;
		}

		this.kbPressed = true;
		this.props.handleKeydown(null, e.target.value.toLowerCase());
		this.setState({kbInput: ''});
	}

	handleKbKeyup() {
		this.kbPressed = false;
	}

	render() {
		const mouseEvents = {
			onTouchStart: this.startToggle,
			onTouchEnd: this.endToggle
		};

		return (
			<div className="keyboard-toggle">
				<input type="text" name="keyboard" maxLength="1" value={this.state.kbInput} onChange={this.handleKbInputChange} ref={(input) => this.kbInput = input} />
				<button {...mouseEvents}>
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#7f7f7f">
						<path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M20 7v10H4V7h16m0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z"/>
					</svg>
				</button>
			</div>
		);
	}
}

export default OnScreenKeyboard;
